import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * TakeAwayStoresApi - axios parameter creator
 * @export
 */
const TakeAwayStoresApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [cid]
         * @param {number} [rid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFront: async (cid, rid, options = {}) => {
            const localVarPath = `/v1/TakeAwayStores/FindFront`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (cid !== undefined) {
                localVarQueryParameter['cid'] = cid;
            }
            if (rid !== undefined) {
                localVarQueryParameter['rid'] = rid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [cid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFrontGroupedLookup: async (cid, options = {}) => {
            const localVarPath = `/v1/TakeAwayStores/FindFrontGroupedLookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (cid !== undefined) {
                localVarQueryParameter['cid'] = cid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStoreById: async (id, options = {}) => {
            const localVarPath = `/v1/TakeAwayStores/FindStoreById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/TakeAwayStores/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [filterVisible]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFront: async (filterVisible, options = {}) => {
            const localVarPath = `/v1/TakeAwayStores/GetAllFront`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filterVisible !== undefined) {
                localVarQueryParameter['filterVisible'] = filterVisible;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/TakeAwayStores/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {TakeAwayStoreToken} [TakeAwayStoreToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (TakeAwayStoreToken, options = {}) => {
            const localVarPath = `/v1/TakeAwayStores/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(TakeAwayStoreToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/TakeAwayStores/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {TakeAwayStoreToken} [TakeAwayStoreToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (TakeAwayStoreToken, options = {}) => {
            const localVarPath = `/v1/TakeAwayStores/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(TakeAwayStoreToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TakeAwayStoresApi - functional programming interface
 * @export
 */
const TakeAwayStoresApiFp = function (configuration) {
    const localVarAxiosParamCreator = TakeAwayStoresApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [cid]
         * @param {number} [rid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findFront(cid, rid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findFront(cid, rid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeAwayStoresApi.findFront']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [cid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findFrontGroupedLookup(cid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findFrontGroupedLookup(cid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeAwayStoresApi.findFrontGroupedLookup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findStoreById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findStoreById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeAwayStoresApi.findStoreById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeAwayStoresApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {boolean} [filterVisible]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFront(filterVisible, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFront(filterVisible, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeAwayStoresApi.getAllFront']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeAwayStoresApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {TakeAwayStoreToken} [TakeAwayStoreToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(TakeAwayStoreToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(TakeAwayStoreToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeAwayStoresApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeAwayStoresApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {TakeAwayStoreToken} [TakeAwayStoreToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(TakeAwayStoreToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(TakeAwayStoreToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeAwayStoresApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TakeAwayStoresApi - factory interface
 * @export
 */
const TakeAwayStoresApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TakeAwayStoresApiFp(configuration);
    return {
        /**
         *
         * @param {number} [cid]
         * @param {number} [rid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFront(cid, rid, options) {
            return localVarFp.findFront(cid, rid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [cid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFrontGroupedLookup(cid, options) {
            return localVarFp.findFrontGroupedLookup(cid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStoreById(id, options) {
            return localVarFp.findStoreById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [filterVisible]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFront(filterVisible, options) {
            return localVarFp.getAllFront(filterVisible, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {TakeAwayStoreToken} [TakeAwayStoreToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(TakeAwayStoreToken, options) {
            return localVarFp.insert(TakeAwayStoreToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {TakeAwayStoreToken} [TakeAwayStoreToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(TakeAwayStoreToken, options) {
            return localVarFp.update(TakeAwayStoreToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TakeAwayStoresApi - object-oriented interface
 * @export
 * @class TakeAwayStoresApi
 * @extends {BaseAPI}
 */
class TakeAwayStoresApi extends BaseAPI {
    /**
     *
     * @param {number} [cid]
     * @param {number} [rid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TakeAwayStoresApi
     */
    findFront(cid, rid, options) {
        return TakeAwayStoresApiFp(this.configuration).findFront(cid, rid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [cid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TakeAwayStoresApi
     */
    findFrontGroupedLookup(cid, options) {
        return TakeAwayStoresApiFp(this.configuration).findFrontGroupedLookup(cid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TakeAwayStoresApi
     */
    findStoreById(id, options) {
        return TakeAwayStoresApiFp(this.configuration).findStoreById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TakeAwayStoresApi
     */
    getAll(options) {
        return TakeAwayStoresApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [filterVisible]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TakeAwayStoresApi
     */
    getAllFront(filterVisible, options) {
        return TakeAwayStoresApiFp(this.configuration).getAllFront(filterVisible, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TakeAwayStoresApi
     */
    getById(id, options) {
        return TakeAwayStoresApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {TakeAwayStoreToken} [TakeAwayStoreToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TakeAwayStoresApi
     */
    insert(TakeAwayStoreToken, options) {
        return TakeAwayStoresApiFp(this.configuration).insert(TakeAwayStoreToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TakeAwayStoresApi
     */
    remove(id, options) {
        return TakeAwayStoresApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {TakeAwayStoreToken} [TakeAwayStoreToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TakeAwayStoresApi
     */
    update(TakeAwayStoreToken, options) {
        return TakeAwayStoresApiFp(this.configuration).update(TakeAwayStoreToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { TakeAwayStoresApi, TakeAwayStoresApiAxiosParamCreator, TakeAwayStoresApiFactory, TakeAwayStoresApiFp };
//# sourceMappingURL=take-away-stores-api.js.map
